import { useScope } from "@state/scopeContext.lib";
import { useOnboardingStatus } from "./useOnboardingStatus";

export enum ApplicationView {
    ONBOARDING = "ONBOARDING",
    MAIN = "MAIN",
    PERSONAL_VIEW = "PERSONAL_VIEW",
    ORGANIZATION_VIEW = "ORGANIZATION_VIEW",
}

export function useApplicationView(): ApplicationView {
    const isOnboarded = useOnboardingStatus();
    const { workspaceId, organizationId } = useScope();

    if (!isOnboarded) {
        return ApplicationView.ONBOARDING;
    }

    if (organizationId && !workspaceId) {
        return ApplicationView.ORGANIZATION_VIEW;
    }

    if (!workspaceId) {
        return ApplicationView.PERSONAL_VIEW;
    }

    return ApplicationView.MAIN;
}
